import { createSlice } from "@reduxjs/toolkit";

const framesSlice = createSlice({
  name: "frames",
  initialState: {
    widgetId: null,
    framesId: null,
    clientPath: null,
    widgetUrl: null,
    isIframe: false,
  },
  reducers: {
    updateFramesDetails: (state, action) => {
      state.framesId = action.payload.framesId;
      state.widgetId = action.payload.widgetId;
      state.clientPath = action.payload.clientPath;
      state.isIframe = action.payload.isIframe;
    },
    updateFramesUrl: (state, action) => {
      state.widgetUrl = action.payload.widgetUrl;
    },
  },
});

export const { updateFramesDetails, updateFramesUrl } = framesSlice.actions;
export default framesSlice.reducer;
